class DictMgr {
  TAG = 'DictMgr loadDic'
  PREFIX = 'Options'
  OPTIONS = {}
  XZQH_TREE = []
  XZQH_MAP = new Map()


  loadDic(type, key, form, formKey = 'data', loadFinishFn) {
    let option = this.OPTIONS[key + this.PREFIX]
    if (option) {
      if (form) form[formKey] = option
      typeof loadFinishFn === 'function' && loadFinishFn(option)
    }
    NetUtil
      .dictData
      .listByType(type)
      .then((res) => {
        if (res && res.code === 200 && res.data) {
          this.OPTIONS[key + this.PREFIX] = res.data
          option = res.data
          if (form) form[formKey] = res.data
        }
      })
      .catch(e => console.error(this.TAG + e))
      .finally(() => {
        typeof loadFinishFn === 'function' && loadFinishFn(option)
      })
  }

  formater(dicDm, key) {
    return DictUtil.dictLabel(this.OPTIONS[key + this.PREFIX], dicDm)
  }

  loadXzqh(loadFinishFn) {
    if (this.XZQH_TREE && this.XZQH_TREE.length > 0 && this.XZQH_MAP && this.XZQH_MAP.size > 0) {
      typeof loadFinishFn === 'function' && loadFinishFn(this.XZQH_TREE)
    }
    NetUtil
      .dept
      .treeSelect()
      .then(res => {
        if (res && res.code === 200) {
          this.XZQH_TREE = res.data
          this.formatList(res.data)
        }
      })
      .finally(() => {
        typeof loadFinishFn === 'function' && loadFinishFn(this.XZQH_TREE)
      })
  }

  formatList(arr) {
    if (arr && arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i])
          this.XZQH_MAP.set(arr[i].sysCode, arr[i])
        if (arr[i].children && arr[i].children.length > 0)
          this.formatList(arr[i].children)
      }
    }
  }

  formaterXzqh(code) {
    let item = this.XZQH_MAP.get(code)
    if (item && item.label) return item.label
    return code
  }


}

export default DictMgr
